import React from 'react';

/** First letter of first name + first letter of last name (e.g. "John Smith" → "JS"). */
export function getPatientFirstLastInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  if (parts.length === 1) return (parts[0][0] || '').toUpperCase();
  return `${(parts[0][0] || '').toUpperCase()}${(parts[parts.length - 1][0] || '').toUpperCase()}`;
}

/** Plain-text label for popovers / title when privacy mode is on. */
export function getPatientPrivacyLabel(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  if (parts.length === 1) {
    const word = parts[0];
    return word.length ? `${word[0].toUpperCase()}.` : '';
  }
  const first = parts[0][0]?.toUpperCase() || '';
  const last = parts[parts.length - 1][0]?.toUpperCase() || '';
  return `${first}. ${last}.`;
}

/**
 * Shows first + last initials clearly; blurs the rest of the name (HIPAA / screen-share).
 */
export function PrivatePatientName({ name, className }) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return null;

  if (parts.length === 1) {
    const word = parts[0];
    if (word.length <= 1) {
      return <span className={className}>{word}</span>;
    }
    return (
      <span className={className}>
        <span>{word[0]}</span>
        <span className="patient-name-privacy-blur">{word.slice(1)}</span>
      </span>
    );
  }

  const firstInitial = parts[0][0] || '';
  const lastPart = parts[parts.length - 1];
  const lastInitial = lastPart[0] || '';
  const blurredAfterFirst = parts[0].slice(1);
  const blurredMiddle =
    parts.length > 2 ? ` ${parts.slice(1, -1).join(' ')} ` : ' ';
  const blurredBeforeLastInitial = lastPart.slice(1);

  return (
    <span className={className}>
      <span>{firstInitial}</span>
      <span className="patient-name-privacy-blur">
        {blurredAfterFirst}
        {blurredMiddle}
        {blurredBeforeLastInitial}
      </span>
      <span>{lastInitial}</span>
    </span>
  );
}
